require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-23-gc-q-6.json") })
        }
      }, "path---photos-professional-23-gc-q-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-23-gc-q-6!./.cache/json/photos-professional-23-gc-q-6.json
// module id = 682
// module chunks = 231608221292675